import script from "./ProfileResearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileResearch.vue?vue&type=script&setup=true&lang=js"

import "./ProfileResearch.vue?vue&type=style&index=0&id=7d8b4bb5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8b4bb5"]])

export default __exports__